/**
 * Окно «Загрузить» в «Результатах»: какие файлы берём — картинки и видео MP4/MOV (сервис узнаёт формат по
 * сигнатуре, здесь — только чтобы не слать заведомо отказное). Потолки — как у сервиса (`media.MAX_BYTES`,
 * `media.MAX_VIDEO_BYTES`). Модуль без импортов — его грузит `node --test`.
 */

const MB = 1024 * 1024;
export const IMAGE_MAX_MB = 25;
export const VIDEO_MAX_MB = 150;

/** `accept` поля выбора файла. */
export const RESULT_ACCEPT = "image/*,video/mp4,video/quicktime,.mov";

type FileLike = { name: string; type: string; size: number };

const isVideoFile = (f: FileLike) =>
  f.type === "video/mp4" || f.type === "video/quicktime" || (!f.type && /\.(mp4|mov|m4v)$/i.test(f.name));

/** Годные файлы по порядку и строки «имя: причина» для отброшенных. */
export function splitResultFiles<T extends FileLike>(list: Iterable<T>): { files: T[]; rejected: string[] } {
  const files: T[] = [];
  const rejected: string[] = [];
  for (const f of list) {
    const name = f.name || "файл";
    if (isVideoFile(f)) {
      if (f.size > VIDEO_MAX_MB * MB) rejected.push(`${name}: видео больше ${VIDEO_MAX_MB} МБ`);
      else files.push(f);
    } else if (f.type.startsWith("image/")) {
      if (f.size > IMAGE_MAX_MB * MB) rejected.push(`${name}: картинка больше ${IMAGE_MAX_MB} МБ`);
      else files.push(f);
    } else {
      rejected.push(`${name}: не картинка и не видео MP4/MOV`);
    }
  }
  return { files, rejected };
}
